"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var SwatchColorPicker_base_1 = require("./SwatchColorPicker.base");
var SwatchColorPicker_styles_1 = require("./SwatchColorPicker.styles");
exports.SwatchColorPicker = Utilities_1.styled(SwatchColorPicker_base_1.SwatchColorPickerBase, SwatchColorPicker_styles_1.getStyles);
//# sourceMappingURL=SwatchColorPicker.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/components/SwatchColorPicker/SwatchColorPicker.js
// module id = 1679
// module chunks = 0